export const relocationOptions = [
  {
    id: 0,
    label: 'NO_RELOCATION',
  },
  {
    id: 1,
    label: 'FROM_EU_WITH_PACKAGE',
  },
  {
    id: 2,
    label: 'FROM_EU_NO_PACKAGE',
  },
  {
    id: 3,
    label: 'FROM_WORLD_WITH_PACKAGE',
  },
  {
    id: 4,
    label: 'FROM_WORLD_NO_PACKAGE',
  },
];
